export default "__VITE_ASSET__DpG5iLnm__"